var _a;
import { initialize as initWriterPopup } from '../../WriterPopup/redux/actions';
import { ModalType } from './types';
export default (_a = {},
    _a[ModalType.JOURNAL] = initWriterPopup,
    _a);
//# sourceMappingURL=initActions.js.map